import React, { useEffect, useState } from 'react';
import moment from 'moment';
import 'moment/locale/fr';

const monthCache = {}; // Objet pour stocker les mois calculés

const Month = (props) => {
    const { locale } = props;
    const [month, setMonth] = useState('');

    useEffect(() => {
        const lowerLocale = String(locale).toLowerCase();
        // Vérifie si la locale est déjà dans le cache
        if (monthCache[lowerLocale]) {
            setMonth(monthCache[lowerLocale]);
        } else {
            moment.locale(lowerLocale);
            const formattedMonth = moment().format('MMMM');
            monthCache[lowerLocale] = formattedMonth; // Ajoute au cache
            setMonth(formattedMonth);
        }
    }, [locale]);

    return (
        <span>
            {month.charAt(0).toUpperCase() + month.slice(1)}
        </span>
    );
};

export default Month;
